// src/services/admin/paypal.service.ts

export interface PayPalPayoutItem {
  recipient_type: 'EMAIL' | 'PHONE' | 'PAYPAL_ID';
  amount: {
    value: string;
    currency: string;
  };
  note: string;
  sender_item_id: string;
  receiver: string;
  alternate_notification_method?: {
    phone: {
      country_code: string;
      national_number: string;
    };
  };
  notification_language?: string;
  purpose?: string;
}

type CreatePayoutPayload = {
  sender_batch_id: string;
  email_subject: string;
  email_message: string;
  items: PayPalPayoutItem[];
};

const PAYPAL_BASE_URL = 'https://api-m.sandbox.paypal.com'; // Use production URL when ready
const CLIENT_ID = import.meta.env.VITE_PAYPAL_CLIENT_ID!;
const CLIENT_SECRET = import.meta.env.VITE_PAYPAL_CLIENT_SECRET_KEY!;

async function getPayPalAccessToken(): Promise<string> {
  // Encode CLIENT_ID:CLIENT_SECRET in Base64
  const credentials = btoa(`${CLIENT_ID}:${CLIENT_SECRET}`);
  
  const response = await fetch(`${PAYPAL_BASE_URL}/v1/oauth2/token`, {
    method: 'POST',
    headers: {
      Authorization: `Basic ${credentials}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: 'grant_type=client_credentials',
  });

  if (!response.ok) throw new Error('Failed to get PayPal access token');

  const data = await response.json();
  console.log(data);
  return data.access_token;
}

export async function sendBatchPayout(payload: CreatePayoutPayload) {
  const token = await getPayPalAccessToken();

  const response = await fetch(`${PAYPAL_BASE_URL}/v1/payments/payouts`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sender_batch_header: {
        sender_batch_id: payload.sender_batch_id,
        email_subject: payload.email_subject,
        email_message: payload.email_message,
      },
      items: payload.items,
    }),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(`PayPal payout failed: ${errorBody}`);
  }

  return await response.json(); // Contains batch ID and details
}
  